import React, { useState } from "react";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { Button } from "antd";
import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { useNavigate } from "react-router-dom";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import mockData from "../../../../utils/schema/mockData";
import { Badge } from "../../../../components/Elements/TextStyles/Badge";
import FilterAssigedForm from "./FilterAssigedForm";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import PermissionForm from "../../../Auth/PermissionForm";
import { useEffect } from "react";
import { useSelector } from "react-redux";
const extendedMockData = [
  {
    _id: "1",
    serial: 1,
    formName: "Basic Details Form",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Jan 2026",
    scope: "Delhi",
    status: "Project Assigned",
    assignedBy: "Jacob Jones",
    endDate: "07/05/2016",
  },
  {
    _id: "2",
    serial: 2,
    formName: "BRSR",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Jan 2026",
    scope: "Delhi- Sales",
    status: "Project Setup Pending",
    assignedBy: "Howard",
    endDate: "07/05/2016",
  },
  {
    _id: "3",
    serial: 3,
    formName: "ESG Survey",
    section: "Section- A Energy",
    project: "OGB017/Carbon Calculator",
    period: "Q1 2026",
    scope: "Sales",
    status: "Project Setup Completed",
    assignedBy: "Cody Fisher",
    endDate: "16/08/2013",
  },
  {
    _id: "4",
    serial: 4,
    formName: "ESG Survey",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Q1 2026",
    scope: "Sales",
    status: "In Progress",
    assignedBy: "Leslie Alexander",
    endDate: "07/05/2016",
  },
  {
    _id: "5",
    serial: 5,
    formName: "EMPLOYEE FORM",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Q2 2026",
    scope: "HR",
    status: "Forms Submitted",
    assignedBy: "Devon Lane",
    endDate: "18/09/2016",
  },
  {
    _id: "6",
    serial: 6,
    formName: "Energy Audit Form",
    section: "Section- A Energy",
    project: "OGB017/Carbon Calculato",
    period: "Q1 2026",
    scope: "HR- Mumbai",
    status: "Report Requested",
    assignedBy: "Theresa Webb",
    endDate: "28/10/2012",
  },
  {
    _id: "7",
    serial: 7,
    formName: "Energy Audit Form",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Q3 2026",
    scope: "Delhi",
    status: "Report Generated",
    assignedBy: "Marvin McKinney",
    endDate: "15/08/2017",
  },
  {
    _id: "8",
    serial: 8,
    formName: "BRSR",
    section: "Section- A Energy",
    project: "OGB017/Carbon Calculator",
    period: "2025",
    scope: "Sales",
    status: "Audit Requested",
    assignedBy: "Bessie Cooper",
    endDate: "12/06/2020",
  },
  {
    _id: "9",
    serial: 9,
    formName: "EMPLOYEE FORM",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "Q3 2026",
    scope: "Delhi- Sales",
    status: "Audit In Progress",
    assignedBy: "Annette Black",
    endDate: "16/08/2013",
  },
  {
    _id: "10",
    serial: 10,
    formName: "BRSR",
    section: "Full Form",
    project: "OGB017/Carbon Calculator",
    period: "2025",
    scope: "HR",
    status: "Audit Completed",
    assignedBy: "Simmons",
    endDate: "12/06/2020",
  },
];

const AssignedForms = ({ formData = extendedMockData }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState(formData);
  const [sortBy, setSortBy] = useState(null);
  const [viewForm, setViewForm] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Form Name & Sections", key: "formName" },
    { label: "Project", key: "project" },
    { label: "Period", key: "period" },
    { label: "Scope", key: "scope" },
    { label: "Status", key: "status" },
    { label: "Assigned By", key: "assignedBy" },
    { label: "End Date", key: "endDate" },
    { label: "Action", key: "action" },
  ];

  const handleSearch = (searchTerm) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    const filtered = formData.filter((item) =>
      headers.some((header) => {
        if (header.key === "action") return false;
        return String(item[header.key]).toLowerCase().includes(lowercasedTerm);
      }),
    );
    setFilteredData(filtered);
  };
  const [showPermission, setPermission] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  const handleSort = (key, order) => {
    const sortedData = SortData({ data: filteredData, key, order });
    setFilteredData(sortedData);
    setSortBy(key);
    setSortOrder(order);
  };

  return (
    <div className=" md:p-6 lg:p-0  mb-20 sm:mb-6 md:mb-6">
      {/* Breadcrumbs */}
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
        <p>Home</p>
        <span>/</span>

        <TextStyles style={{ color: "#06513D" }}>Assigned Form</TextStyles>
      </div>
      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        {/* <IoArrowBackCircleOutline
          onClick={() => navigate(-1)}
          className="w-7 h-7 sm:w-10 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
        /> */}
        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] font-bold">
          Assigned Form
        </div>
      </div>

      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
          backgroundColor: "#fff",
        }}
      >
        <div className="flex justify-between px-3 mb-3">
          <div className="flex gap-4 pl-9">
            <div className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
              TOTAL FORMS
            </div>
            <SearchBar width="332px" height="42px" onSearch={handleSearch} />
          </div>
          <div className="flex gap-4">
            <Button
              style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5"
              onClick={() => setOpenFilterDialog(true)}
            >
              <FilterIcon />
              FILTER
            </Button>
          </div>
        </div>

        <div className="">
          <Tables
            headers={headers}
            pageSize={10}
            onSort={handleSort}
            sortBy={sortBy}
            sortOrder={sortOrder}
            data={(filteredData || []).map((item, index) => ({
              ...item,
              serial: (
                <div className="text-center font-normal text-gray-600">
                  {index + 1}
                </div>
              ),
              formName: (
                <div className="flex flex-col text-center py-2 items-center justify-center font-normal text-gray-600">
                  <span>{item.formName}</span>
                  <span className="text-sm">{item.section}</span>
                </div>
              ),
              project: (
                <div className="text-center text-gray-600 font-normal">
                  {item.project}
                </div>
              ),
              period: (
                <div className="text-center text-gray-600 font-normal">
                  {item.period}
                </div>
              ),
              scope: (
                <div className="text-center text-gray-600 font-normal">
                  {item.scope}
                </div>
              ),
              assignedBy: (
                <div className="text-center text-gray-600 font-normal">
                  {item.assignedBy}
                </div>
              ),
              endDate: (
                <div className="text-center text-gray-600 font-normal">
                  {item.endDate}
                </div>
              ),
              status: (
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  title=""
                >
                  <Badge text={item.status} />
                </div>
              ),

              action: (
                <div className="flex gap-4 justify-center" title="">
                  <EyeIcon
                    className="cursor-pointer"
                    onClick={() => {
                      console.log("Navigating to ID:", item._id);
                      navigate(`/organization/assigned-form/view/${item._id}`);
                    }}
                  />
                  <EditIcon className="cursor-pointer" />
                </div>
              ),
            }))}
          />

          {openFilterDialog && (
            <FilterAssigedForm
              onOpen={openFilterDialog}
              onClose={() => setOpenFilterDialog(false)}
            />
          )}
        </div>
      </div>
      {/* {viewForm !== null && (
          <ViewDynamicForm
            viewForm={viewForm}
            onClose={() => {
              setViewForm(null);
            }}
          />
        )} */}
    </div>
  );
};

export default AssignedForms;

// import React, { useState } from "react";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { Button, Pagination } from "antd";
// import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-icon.svg";
// import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { useNavigate } from "react-router-dom";
// import SortData from "../../../../components/Elements/SortData.js/SortData";
// import mockData from "../../../../utils/schema/mockData";
// import { Badge } from "../../../../components/Elements/TextStyles/Badge";
// import FilterAssigedForm from "./FilterAssigedForm";
// import { THEME_COLORS } from "../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";

// const MobileFormCard = ({ item, index, navigate }) => {
//   const [isVisible, setIsVisible] = useState(false);

//   React.useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsVisible(true);
//     }, index * 100); // Stagger animation

//     return () => clearTimeout(timer);
//   }, [index]);

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "active":
//       case "completed":
//         return "bg-green-50 text-green-700 border-green-200";
//       case "pending":
//         return "bg-yellow-50 text-yellow-700 border-yellow-200";
//       case "inactive":
//       case "rejected":
//         return "bg-red-50 text-red-700 border-red-200";
//       default:
//         return "bg-gray-50 text-gray-700 border-gray-200";
//     }
//   };

//   return (
//     <div
//       className={`transform transition-all duration-500 ease-out ${
//         isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
//       }`}
//     >
//       <div
//         className="bg-white rounded-xl shadow-md border border-gray-100 p-4 mb-4 hover:shadow-lg transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
//         style={{
//           background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
//           // borderLeft: "4px solid #06513D"
//         }}
//       >
//         {/* Header with Serial and Status */}
//         <div className="flex justify-between items-start mb-3">
//           <div className="flex items-center gap-2">
//             <div className="w-8 h-8 bg-[#06513D] text-white rounded-full flex items-center justify-center text-sm font-semibold">
//               #{item.serial}
//             </div>
//           </div>
//           <div
//             className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(item.status)}`}
//           >
//             {item.status}
//           </div>
//         </div>

//         {/* Form Name */}
//         <div className="flex justify-between items-center mb-3">
//           <span className="text-sm font-medium text-gray-600">Form Name</span>
//           <h3 className="font-semibold text-[#06513D] text-right max-w-[65%] leading-tight">
//             {item.formName}
//           </h3>
//         </div>

//         {/* Company Info */}
//         <div className="flex justify-between items-center mb-3">
//           <span className="text-sm font-medium text-gray-600">Company</span>
//           <p className="text-gray-800 text-sm text-right max-w-[65%] bg-gray-50 px-3 py-1 rounded-lg">
//             {item.companyName}
//           </p>
//         </div>

//         {/* End Date */}
//         <div className="flex justify-between items-center mb-4">
//           <span className="text-sm font-medium text-gray-600">End Date</span>
//           <p className="text-gray-800 text-sm text-right bg-gray-50 px-3 py-1 rounded-lg">
//             {item.endDate}
//           </p>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex justify-center gap-3 pt-3 border-t border-gray-100">
//           <button
//             onClick={() => {
//               console.log("Navigating to ID:", item._id);
//               navigate(`/organization/assigned-form/view/${item._id}`);
//             }}
//             className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors duration-200 text-sm font-medium"
//           >
//             <EyeIcon className="w-4 h-4" />
//             View
//           </button>
//           <button className="flex items-center gap-2 px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors duration-200 text-sm font-medium">
//             <EditIcon className="w-4 h-4" />
//             Edit
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const AssignedForms = ({ formData = mockData }) => {
//   const navigate = useNavigate();
//   const [filteredData, setFilteredData] = useState(formData);
//   const [sortBy, setSortBy] = useState(null);
//   const [viewForm, setViewForm] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [openFilterDialog, setOpenFilterDialog] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const pageSize = 7;

//   const headers = [
//     { label: "#", key: "serial" },
//     { label: "Form Name", key: "formName" },
//     { label: "Company Name", key: "companyName" },
//     { label: "End Date", key: "endDate" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ];

//   const handleSearch = (searchTerm) => {
//     setLoading(true);
//     const lowercasedTerm = searchTerm.toLowerCase();
//     const filtered = formData.filter((item) =>
//       headers.some((header) => {
//         if (header.key === "action") return false;
//         return String(item[header.key]).toLowerCase().includes(lowercasedTerm);
//       }),
//     );
//     setTimeout(() => {
//       setFilteredData(filtered);
//       setCurrentPage(1);
//       setLoading(false);
//     }, 300);
//   };

//   const handleSort = (key, order) => {
//     const sortedData = SortData({ data: filteredData, key, order });
//     setFilteredData(sortedData);
//     setSortBy(key);
//     setSortOrder(order);
//   };

//   // Pagination for mobile
//   const startIndex = (currentPage - 1) * pageSize;
//   const endIndex = startIndex + pageSize;
//   const currentPageData = filteredData.slice(startIndex, endIndex);

//   return (
//     <div className="w-full max-w-full overflow-x-hidden">
//       {/* Main Container */}
//       <div className="px-3 sm:px-4 md:px-6 lg:px-0 mb-20 sm:mb-6 md:mb-6">
//         {/* Breadcrumbs */}
//         <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2  ">
//           <p>Home</p>
//           <span>/</span>
//           <TextStyles style={{ color: "#06513D" }}>Assigned Form</TextStyles>
//         </div>

//         {/* Header Section */}
//         <div className="flex items-center gap-2 sm:gap-3 mb-1 text-lg sm:text-xl font-bold flex-wrap">
//           {/* <IoArrowBackCircleOutline
//             onClick={() => navigate(-1)}
//             className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer flex-shrink-0"
//           /> */}
//           <div className="text-[#06513D] font-[Calibri] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
//             Assigned Form
//           </div>
//         </div>

//         {/* Main Content Card */}
//         <div
//           className="w-full overflow-hidden"
//           style={{
//             border: "1px solid #3BA2B959",
//             borderRadius: "10px",
//             paddingTop: "15px",
//             boxShadow: "0px 0px 16px 0px #3BA2B91F",
//             backgroundColor: "#fff",
//           }}
//         >
//           {/* Controls Section */}
//           <div className="px-3 sm:px-4 md:px-6 mb-4">
//             {/* Desktop Layout */}
//             <div className="hidden lg:flex justify-between items-center">
//               <div className="flex gap-4 items-center">
//                 <div className="px-6 xl:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm xl:text-base font-light whitespace-nowrap">
//                   TOTAL FORMS {filteredData.length}
//                 </div>
//                 <SearchBar
//                   width="280px"
//                   height="42px"
//                   onSearch={handleSearch}
//                 />
//               </div>
//               <div className="flex gap-4">
//                 <Button
//                   style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
//                   className="text-[12px] text-[#06513D] font-light px-4 py-5 h-[42px] flex items-center"
//                   onClick={() => setOpenFilterDialog(true)}
//                 >
//                   <FilterIcon className="mr-2" />
//                   FILTER
//                 </Button>
//               </div>
//             </div>

//             {/* Tablet Layout */}
//             <div className="hidden md:flex lg:hidden flex-col gap-3">
//               <div className="flex justify-between items-center">
//                 <div className="px-4 h-[38px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm font-light whitespace-nowrap">
//                   TOTAL FORMS {filteredData.length}
//                 </div>
//                 <Button
//                   style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
//                   className="text-[12px] text-[#06513D] font-light px-4 h-[38px] flex items-center"
//                   onClick={() => setOpenFilterDialog(true)}
//                 >
//                   <FilterIcon className="mr-2" />
//                   FILTER
//                 </Button>
//               </div>
//               <div className="w-full">
//                 <SearchBar width="100%" height="38px" onSearch={handleSearch} />
//               </div>
//             </div>

//             {/* Mobile Layout */}
//             <div className="flex md:hidden flex-col gap-3">
//               <div className="flex justify-between items-center">
//                 <div className="px-3 h-[36px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-xs font-light whitespace-nowrap">
//                   TOTAL FORMS {filteredData.length}
//                 </div>
//                 <Button
//                   style={{ background: "#E6EEEC", border: "solid 1px #0087A3" }}
//                   className="text-[11px] text-[#06513D] font-light px-3 h-[36px] flex items-center"
//                   onClick={() => setOpenFilterDialog(true)}
//                 >
//                   <FilterIcon className="mr-1 w-3 h-3" />
//                   FILTER
//                 </Button>
//               </div>
//               <div className="w-full">
//                 <SearchBar width="100%" height="36px" onSearch={handleSearch} />
//               </div>
//             </div>
//           </div>

//           {/* Desktop Table View */}
//           <div className="hidden md:block w-full overflow-x-auto">
//             <Tables
//               headers={headers}
//               pageSize={pageSize}
//               onSort={handleSort}
//               sortBy={sortBy}
//               sortOrder={sortOrder}
//               data={(filteredData || []).map((item) => ({
//                 key: item._id || item.serial,
//                 serial: <div className="text-center">{item.serial}</div>,
//                 formName: <div className="text-center">{item.formName}</div>,
//                 companyName: (
//                   <div className="text-center">{item.companyName}</div>
//                 ),
//                 endDate: <div className="text-center">{item.endDate}</div>,
//                 status: (
//                   <div className="flex justify-center items-center">
//                     <Badge text={item.status} />
//                   </div>
//                 ),
//                 action: (
//                   <div className="flex gap-2 sm:gap-3 justify-center items-center">
//                     <EyeIcon
//                       className="cursor-pointer w-4 h-4 sm:w-5 sm:h-5"
//                       onClick={() => {
//                         console.log("Navigating to ID:", item._id);
//                         navigate(
//                           `/organization/assigned-form/view/${item._id}`,
//                         );
//                       }}
//                     />
//                     <EditIcon className="cursor-pointer w-4 h-4 sm:w-5 sm:h-5" />
//                   </div>
//                 ),
//               }))}
//             />
//           </div>

//           {/* Mobile Card View */}
//           <div className="md:hidden px-3 pb-4">
//             {loading ? (
//               <div className="flex justify-center items-center py-12">
//                 <div className="relative">
//                   <div className="w-10 h-10 border-4 border-[#06513D] border-t-transparent rounded-full animate-spin"></div>
//                   <div className="absolute inset-0 w-10 h-10 border-4 border-[#06513D] border-opacity-20 rounded-full"></div>
//                 </div>
//               </div>
//             ) : filteredData.length === 0 ? (
//               <div className="flex flex-col items-center justify-center py-12">
//                 <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
//                   <div className="text-2xl text-gray-400">📋</div>
//                 </div>
//                 <div className="text-gray-500 text-center">
//                   <p className="font-medium">No forms found</p>
//                   <p className="text-sm mt-1">
//                     Try adjusting your search criteria
//                   </p>
//                 </div>
//               </div>
//             ) : (
//               <>
//                 {/* Cards with staggered animation */}
//                 <div className="space-y-1">
//                   {currentPageData.map((item, index) => (
//                     <MobileFormCard
//                       key={item._id || index}
//                       item={item}
//                       index={index}
//                       navigate={navigate}
//                     />
//                   ))}
//                 </div>

//                 {/* Mobile Pagination */}
//                 {filteredData.length > pageSize && (
//                   <div className="flex justify-center mt-6 pt-4 border-t border-gray-100">
//                     <Pagination
//                       current={currentPage}
//                       total={filteredData.length}
//                       pageSize={pageSize}
//                       onChange={(page) => setCurrentPage(page)}
//                       showSizeChanger={false}
//                       size="small"
//                       showQuickJumper={false}
//                       showTotal={(total, range) =>
//                         `${range[0]}-${range[1]} of ${total} forms`
//                       }
//                     />
//                   </div>
//                 )}
//               </>
//             )}
//           </div>

//           {/* Filter Dialog */}
//           {openFilterDialog && (
//             <FilterAssigedForm
//               onOpen={openFilterDialog}
//               onClose={() => setOpenFilterDialog(false)}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AssignedForms;
